import { set } from 'cerebral/operators'
import { state } from 'cerebral/tags'
import setCurrentView from 'modules/App/factories/setCurrentView'

export default [
  setCurrentView({ view: 'media', showSort: false }),
  set(state`media.sortType`, 'LATEST')
]



// WEBPACK FOOTER //
// ./src/modules/Startpage/chains/getStarted.js